



















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class Humburguer extends Vue {
  @Prop({ default: '40' }) readonly width?: string;
  @Prop({ default: '40' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly fill?: string;
}
